import React from 'react'
import LocalShipping from '@mui/icons-material/LocalShipping';
import loadable from '@loadable/component'


 const MasterItemConfig = {
    icon: <LocalShipping />,
    list: loadable(() => import("./MasterItemList")),
    // create: MasterItemCreate,
    edit: loadable(() => import("./MasterItemEdit")),
    options: {
        label: 'Master Item',
        items: true
    }
};

export default MasterItemConfig